import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartTitle
} from '@progress/kendo-react-charts';

import BobLoadingMask from '../../../components/BobLoadingMask';

const PowerGraph = ({
    bobLoading,
    dashboardEndTimeStamp,
    data,
    desiredInterval,
    hasInitialized,
    ...props
}) => {
    const [scoreChartHeight, setScoreChartHeight] = useState('80vh');
    const minWidth2560 = matchMedia('(min-width: 2560px');
    const zoom125 = matchMedia('(min-resolution: 1.25dppx');
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        if (!isEmpty(data)) {
            let dataSet = [];
            let targetData = [];

            data.energyTimeSeries.currentTimeSeries.forEach(item => {
                item.start = new Date(item.start);
                targetData.push({ start: item.start, energyUse: data.targetAverageValue });
            });
            dataSet.push({ name: 'Power, kW', data: data.energyTimeSeries.currentTimeSeries });

            data.energyTimeSeries.priorTimeSeries.forEach((item, index) => {
                item.start = new Date(data.energyTimeSeries.currentTimeSeries[index].start);
            });
            dataSet.push({ name: 'Power, kW (Previous Period)', data: data.energyTimeSeries.priorTimeSeries });

            dataSet.push({ name: 'Energy Target', data: targetData });

            setChartData(dataSet);
        }
    }, [data]);


    const updateScoreChart2560 = (e) => {
        if (e.matches) {
            setScoreChartHeight('70vh');
        }
        else {
            setScoreChartHeight('80vh');
        }

    };

    const mqlZoom125 = (e) => {
        if (e.matches) {
            setScoreChartHeight('49vh');
        }
        else {
            setScoreChartHeight('60vh');
        }
    };

    useEffect(() => {
        return () => {
            minWidth2560.removeEventListener('change', updateScoreChart2560);
            zoom125.removeEventListener('change', mqlZoom125);
        };
    }, []);

    useEffect(() => {
        if (window.devicePixelRatio === 1) {
            setScoreChartHeight('60vh');
        }
        else {
            setScoreChartHeight('49vh');
        }

        minWidth2560.addEventListener('change', updateScoreChart2560);
        zoom125.addEventListener('change', mqlZoom125);

        const mediaQuery = window.matchMedia('(min-width: 2560px)');
        if (mediaQuery.matches) {
            updateScoreChart2560(mediaQuery);
        }

    }, []);

    return (
        <div>
            <div>
                <Chart
                    style={{
                        height: scoreChartHeight
                    }}
                    pannable={{ lock: 'y' }}
                    zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                >
                    <ChartTitle text={'Power Chart'} align="left" font="12pt sans-serif" />
                    <ChartTooltip
                        shared={true} visible={true} //render={sharedTooltipRender}
                        background="#FFFFFF"
                        opacity={.95}
                    />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            baseUnit="auto"
                            maxDivisions={12}
                            labels={{ visible: true }}
                        />
                    </ChartCategoryAxis>
                    <ChartLegend position="top" orientation="horizontal" visible={true} />
                    <ChartSeries>
                        {chartData.map((item, index) => (
                            <ChartSeriesItem
                                type="line"
                                markers={{ visible: false }}
                                categoryField="start"
                                name={item.name}
                                key={index}
                                data={item.data}
                                field="energyUse"
                                unit={item.unit}
                                // eslint-disable-next-line react/style-prop-object
                                style="smooth"
                            />
                        ))}
                    </ChartSeries>
                </Chart>
                {
                    bobLoading.includes('FetchEquipmentEnergyData') || bobLoading.includes('FetchSiteEnergyData') || !hasInitialized ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};


const mapStateToProps = state => {
    return {
        bobLoading:            state.bob.bobLoading,
        dashboardEndTimeStamp: state.dashboard.dashboardEndTimeStamp,
        desiredInterval:       state.dashboard.desiredInterval

    };
};

export default connect(mapStateToProps, null)(PowerGraph);
